class Account {
  public addresses: NodeListOf<HTMLElement> | null;
  public addAddressButton: HTMLButtonElement | null;

  cache() {
    this.addresses = document.querySelectorAll('.js-account-address');
    this.addAddressButton = document.querySelector('.js-account-address-add');
  }

  bindings() {
    if (this.addresses) {
      this.addresses.forEach((address: HTMLElement) => {
        this.handleDelete(address);
      });
    }

    if (this.addAddressButton) {
      this.addAddressButton.addEventListener('click', (e: Event) => {
        e.preventDefault();

        this.addAddress();
      });
    }
  }

  handleDelete(address: HTMLElement) {
    const deleteButton: HTMLElement | null = address.querySelector('.js-account-address-delete');

    deleteButton?.addEventListener('click', (e: Event) => {
      e.preventDefault();

      // @ts-ignore
      if (this.addresses.length > 1) {
        const isDefaultRadio: HTMLInputElement | null = address.querySelector('input[type="radio"]');

        address.remove();

        // reupdate the addresses
        this.reCacheAddresses();

        if (isDefaultRadio && isDefaultRadio.checked) {
          const nextAvailableElement: HTMLElement | undefined = this.addresses?.item(0);

          if (nextAvailableElement) {
            const nextAvailableElementDefaultRadio: HTMLInputElement | null = nextAvailableElement.querySelector('input[type="radio"]');

            // @ts-ignore
            nextAvailableElementDefaultRadio.checked = true;
          }
        }
      }
    });
  }

  addAddress() {
    // @ts-ignore
    const [firstAddress] = this.addresses;

    const oldAddressIndex = Number(firstAddress.dataset.index);

    let newAddressString = firstAddress.outerHTML;

    const currentAddressesLength = this.addresses ? this.addresses.length : 0;

    // lil hacky -> changed /(?<=value=")(.*)(?=" p)/g to the new regex because of stupid safari
    const inputValueRegex = /(input.*value=")(.*?)(")/g;
    newAddressString = newAddressString
      .replaceAll(inputValueRegex, '$1$3')
      .replace('checked=""', '')
      .replace('display: none;', '')
      .replaceAll(`addresses[${oldAddressIndex}]`, `addresses[${currentAddressesLength}]`)
      .replaceAll(`defaultAddress-${oldAddressIndex}`, `defaultAddress-${currentAddressesLength}`)
      .replace(`data-index="${oldAddressIndex}"`, `data-index="${currentAddressesLength}"`)
      .replace(`adresse ${oldAddressIndex + 1}`, `adresse ${currentAddressesLength + 1}`);

    const parser = new DOMParser();
    // console.log('newAddressString', newAddressString);
    const addressWithDOM = parser.parseFromString(newAddressString, 'text/html');

    // @ts-ignore
    const lastAddressInList = this.addresses.item(currentAddressesLength - 1);

    const newAddress = addressWithDOM.body?.firstChild as HTMLElement;

    // @ts-ignore
    lastAddressInList.parentNode?.insertBefore(newAddress, lastAddressInList.nextSibling);

    this.reCacheAddresses();

    this.handleDelete(newAddress);
  }

  reCacheAddresses() {
    this.addresses = document.querySelectorAll('.js-account-address');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Account;
